
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";

export default defineComponent({
  name: "urusan-laporan",
  components: {},
  props: {},
  setup(root) {
    const baseURL = ref(
      // "http://175.139.185.141:8080/jasperserver/flow.html?_flowId=searchFlow&lastMode=true&pp=9OHyvTyNrZCq8pPf6i4OS1aSlPlOS9tLaSP6PglN3FFqg8JzDvileXmBKiA92yRIH2CTZxV9AVgDrRujfLZLDg%3D%3D"
      process.env.VUE_APP_REPORT_URL +
        "flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&pp=9OHyvTyNrZCq8pPf6i4OS1aSlPlOS9tLaSP6PglN3FFqg8JzDvileXmBKiA92yRIH2CTZxV9AVgDrRujfLZLDg%3D%3D&ParentFolderUri=%2FJANM_Reports%2FLaporan_Pengguna&reportUnit=%2FJANM_Reports%2FLaporan_Pengguna%2FLPE_PE04_Audit_Trail&standAlone=true&decorate=no"
    );
    const laporan = ref([
      {
        color: "warning",
        icon: "icons/duotune/abstract/abs027.svg",
        title: "Senarai Permohonan Mengikut Urusan Peperiksaan",
        text: "31 Mar 2022",
        number: "+28%",
      },
      {
        color: "success",
        icon: "icons/duotune/art/art005.svg",
        title: "Laporan Statistik Permohonan Mengikut Tahun",
        text: "05 Mar 2022",
        number: "+50%",
      },
      {
        color: "danger",
        icon: "icons/duotune/communication/com012.svg",
        title: "Laporan Mengikut Kerajaan / Jabatan / Agensi",
        text: "14 Feb 2022",
        number: "-27%",
      },
      {
        color: "info",
        icon: "icons/duotune/communication/com012.svg",
        title: "Laporan Senarai Calon Mengikut Pusat Peperiksaan",
        text: "01 Feb 2022",
        number: "+8%",
      },
      {
        color: "info",
        icon: "icons/duotune/communication/com012.svg",
        title: "Laporan Keputusan Mengikut Peperiksaan",
        text: "01 Feb 2022",
        number: "+8%",
      },
      {
        color: "info",
        icon: "icons/duotune/communication/com012.svg",
        title: "Laporan Keputusan Mengikut Pusat Peperiksaan",
        text: "01 Feb 2022",
        number: "+8%",
      },
    ]);
    onMounted(() => {
      setCurrentPageBreadcrumbs("Senarai Pengguna Aktif/Tidak Aktif", [
        "Laporan",
        "Pentadbiran Sistem",
      ]);
    });

    return {
      laporan,
      baseURL,
    };
  },
});
